<template>
  <main-large-dialog
    v-bind="$props"
    :is-visible.sync="computedIsVisible"
    :title="$i18n.t('dialog.title.patternDetails')"
    no-paddings-y
    no-paddings-x
    dialog-width="45%"
    max-height="80vh"
    bodyHeight="60vh"
    header-shadow
    agree-text="dialog.agreeSave"
    @modalClosed="$emit('modalClosed')"
    @agree="handlePattern"
    :loading="isLoading"
    :is-valid="isValid"
  >
    <template #body>
      <v-row no-gutters>
        <v-col>
          <v-form v-model="isValid">
            <v-row no-gutters class="nameRow">
              <v-col cols="10">
                <main-input-dialog-row name="name" translationPath="dialog.body.name" align="baseline">
                  <template #name.input>
                    <v-col cols="6">
                      <data-input
                        outlined
                        dense
                        v-model="name"
                        v-on="$listeners"
                        :data-type="dataTypeText"
                        :rules="[v => !!v || v == '0' || 'rules.required']"
                      ></data-input>
                    </v-col>
                  </template>
                </main-input-dialog-row>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="8">
                <template v-if="treeisPrepared">
                  <ZDMLanternPatternTreeview
                    :pattern="preparedTree"
                    :pole-type-features="poleTypeFeatures"
                    :head-type-features="headTypeFeatures"
                    :pick-arm-features="pickArmFeatures"
                  />
                </template>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </template>
  </main-large-dialog>
</template>

<script>
import { call, get } from 'vuex-pathify';
import MainInputDialogRow from '@/components/MainInputDialogRow';
import DataInput from '@/components/DataInput';
import ZDMLanternPatternTreeview from '@/components/ZDMLanternPatternTreeview';
import MainLargeDialog from '@/components/MainLargeDialog';

export default {
  name: 'LanternPatternDialog',
  components: {
    ZDMLanternPatternTreeview,
    DataInput,
    MainInputDialogRow,
    MainLargeDialog,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    pattern: {
      type: Object,
      default: () => {},
    },
    poleTypeFeatures: {
      type: Array,
      default: () => [],
    },
    pickArmFeatures: {
      type: Array,
      default: () => [],
    },
    headTypeFeatures: {
      type: Array,
      default: () => [],
    },
  },
  data: vm => ({
    dataTypeText: {
      name: 'text',
    },
    isLoading: false,
    treeisPrepared: false,
    name: vm.pattern.name || '',
    preparedTree: [],
    isValid: false,
  }),
  computed: {
    /*    isValid() {
      const payload = {
        name: this.name,
        catalog_pole_id: this.preparedTree[0]?.children[0].value,
        catalog_pick_arm_id: this.preparedTree[0]?.children[0].children[0].value,
        catalog_heads_id: this.preparedTree[0]?.children[0].children[0].children.map(item => item.value),
        catalog_pick_arm_other_id: this.preparedTree[0]?.children[0].children[1]?.value,
        catalog_heads_other_id: this.preparedTree[0]?.children[0].children[1]?.children.map(item => item.value),
      };
      console.log(payload.catalog_heads_id);
      if (!payload.name) {
        return false;
      }
      if (
        !payload.catalog_pole_id ||
        payload.catalog_heads_id?.length === 0 ||
        payload.catalog_heads_id?.some(item => item === undefined)
      ) {
        console.log(payload.catalog_heads_id);
        return false;
      }
      return true;
    },*/
    lanternPatterns: get('zdm_data/lanternPatterns'),
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    handlePattern() {
      return this.isNew ? this.handleAdd : this.handleEdit;
    },
    isNew() {
      return !this.pattern.id;
    },
    nameAlreadyUsed() {
      return this.lanternPatterns
        .filter(pattern => pattern.name !== this.pattern.name)
        .some(pattern => pattern.name === this.name);
    },
  },
  methods: {
    addPattern: call('zdm_data/addPattern'),
    editPattern: call('zdm_data/editPattern'),
    preparePattern() {
      const patternObject = {
        pole: this.pattern.catalog_pole_id || [undefined],
        pick_arm: this.pattern.catalog_pick_arm_id || [undefined],
        heads: this.pattern.catalog_heads_id || [undefined],
        ...(this.pattern.catalog_pick_arm_other_id && { pick_arm_other: this.pattern.catalog_pick_arm_other_id }),
        ...(this.pattern.catalog_heads_other_id && { heads_other: this.pattern.catalog_heads_other_id }),
      };
      return this.prepareTree(patternObject);
    },
    prepareTree(patternObject) {
      return [
        {
          name: this.$i18n.t('admin.street_lamp'),
          level: 1,
          children: [
            {
              name: this.$i18n.t('admin.pole'),
              selectItems: this.poleTypeFeatures,
              value: patternObject.pole,
              level: 2,
              children: [
                {
                  name: this.$i18n.t('admin.pick_arm_primary'),
                  selectItems: this.pickArmFeatures,
                  value: patternObject.pick_arm,
                  index: 0,
                  level: 3,
                  children: patternObject.heads.map((item, index) => {
                    return {
                      value: item,
                      index,
                      level: 4,
                      name: this.$i18n.t('admin.light_head'),
                      parentIndex: 0,
                      selectItems: this.headTypeFeatures,
                    };
                  }),
                },
                ...(patternObject.heads_other
                  ? [
                      {
                        name: this.$i18n.t('admin.pick_arm_secondary'),
                        level: 3,
                        index: 1,
                        value: patternObject.pick_arm_other,
                        selectItems: this.pickArmFeatures,
                        children: patternObject.heads_other.map((item, index) => {
                          return {
                            value: item,
                            index,
                            name: this.$i18n.t('admin.light_head'),
                            parentIndex: 1,
                            level: 4,
                            selectItems: this.headTypeFeatures,
                          };
                        }),
                      },
                    ]
                  : []),
              ],
            },
          ],
        },
      ];
    },
    resetPayload() {
      this.name = '';
      this.preparedTree = this.preparePattern();
    },
    async handleAdd() {
      this.isLoading = true;
      const payload = {
        name: this.name,
        catalog_pole_id: this.preparedTree[0].children[0].value,
        catalog_pick_arm_id: this.preparedTree[0].children[0].children[0].value,
        catalog_heads_id: this.preparedTree[0].children[0].children[0].children.map(item => item.value),
        catalog_pick_arm_other_id: this.preparedTree[0].children[0].children[1]?.value,
        catalog_heads_other_id: this.preparedTree[0].children[0].children[1]?.children.map(item => item.value),
      };
      if (this.nameAlreadyUsed) {
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.patternAlreadyExists'),
        });
        this.isLoading = false;
        return;
      }
      try {
        await this.addPattern(payload);
      } finally {
        this.isLoading = false;
        this.$emit('modalClosed');
        this.computedIsVisible = false;
        this.resetPayload();
      }
    },
    async handleEdit() {
      this.isLoading = true;
      const body = {
        name: this.name,
        catalog_pole_id: this.preparedTree[0].children[0].value,
        catalog_pick_arm_id: this.preparedTree[0].children[0].children[0].value,
        catalog_heads_id: this.preparedTree[0].children[0].children[0].children.map(item => item.value),
        catalog_pick_arm_other_id: this.preparedTree[0].children[0].children[1]?.value,
        catalog_heads_other_id: this.preparedTree[0].children[0].children[1]?.children.map(item => item.value),
      };
      if (this.nameAlreadyUsed) {
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.patternAlreadyExists'),
        });
        this.isLoading = false;
        return;
      }
      try {
        await this.editPattern({ pattern_id: this.pattern.id, body });
      } finally {
        this.isLoading = false;
        this.$emit('modalClosed');
        this.computedIsVisible = false;
      }
    },
  },
  mounted() {
    this.preparedTree = this.preparePattern();
    this.treeisPrepared = true;
  },
};
</script>

<style scoped lang="scss">
.nameRow {
  align-items: baseline;
  justify-content: flex-start;
  margin: 0;
  padding: 24px 0 12px 24px;
}
</style>
